export default __webpack_public_path__ + "static/media/team-photo-1984.42d023cb.jpg";